import popUpsApi from "../../api/pop-ups-api";

const popUps = {
  items: [],
  item: {},
  listSelect: [],
  popupNewPopUp: false,
  popupEditPopUp: false,
  popupSeePopUp: false,
  createdCorrect: false,
};

const mutations = {
  setItemsPopUps(state, payload) {
    state.items = payload.data;
  },
  setItemPopUp(state, payload) {
    state.item = payload;
  },
  setSelectPopUps(state, payload) {
    state.listSelect = payload.data;
  },

  setpopupNewPopUp(state, payload) {
    state.popupNewPopUp = payload;
  },
  setpopupEditPopUp(state, payload) {
    state.popupEditPopUp = payload;
  },
  setpopupSeePopUp(state, payload) {
    state.popupSeePopUp = payload;
  },
  setCreatedCorrect(state, payload) {
    state.createdCorrect = payload;
  },
};

const actions = {
  async refreshPopUps(context, { restaurant_id }) {
    if (!restaurant_id) {
      restaurant_id = null;
    }

    context.commit("loading", true);
    const res = await popUpsApi.getAllPopUps(restaurant_id);

    context.commit("loading", false);
    context.commit("setItemsPopUps", res);
  },

  async getPopUp(context, { id, language }) {
    context.commit("loading", true);
    context.commit("setItemPopUp", {});
    popUpsApi.getOne(id, language).then(
      (response) => {
        context.commit("setItemPopUp", response.data);
        context.commit("loading", false);
      },
      (error) => {
        context.commit("loading", false);
      }
    );
  },

  createPopUp({ commit, dispatch }, { popUp, language, restaurant_id }) {
    commit("loading", true);
    popUpsApi.create(popUp, language).then(
      (response) => {
        dispatch("refreshPopUps", {
          restaurant_id,
        });
        commit("notifications", { title: "popUps.CreatedPopUp" });
        commit("setpopupNewPopUp", false);
        commit("loading", false);
        commit("showNotifications", true);
        commit("setCreatedCorrect", true);
      },
      (error) => {
        commit("loading", false);
        commit("notifications", {
          title: "popUps.CreatedPopUpKO",
          color: "danger",
        });
        commit("showNotifications", true);
      }
    );
  },

  deletePopUp({ commit, dispatch }, { id, restaurant_id }) {
    commit("loading", true);
    popUpsApi.delete(id).then(
      (response) => {
        dispatch("refreshPopUps", {
          restaurant_id: restaurant_id ? restaurant_id : null,
        });
        commit("notifications", { title: "popUps.DeletedPopUp" });
        commit("loading", false);
        commit("showNotifications", true);
      },
      (error) => {
        commit("notifications", {
          title: "popUps.DeletePopUpKO",
          color: "danger",
        });
        commit("loading", false);
        commit("showNotifications", true);
      }
    );
  },

  activePopUp({ commit, dispatch }, { id, restaurant_id }) {
    commit("loading", true);
    popUpsApi.active(id).then(
      (response) => {
        dispatch("refreshPopUps", {
          restaurant_id: restaurant_id ? restaurant_id : null,
        });
        commit("notifications", { title: "popUps.ActivatePopUpOK" });
        commit("loading", false);
        commit("showNotifications", true);
      },
      (error) => {
        commit("notifications", {
          title: "popUps.ActivatePopUpKO",
          color: "danger",
        });
        commit("loading", false);
        commit("showNotifications", true);
      }
    );
  },

  deactivePopUp({ commit, dispatch }, { id, restaurant_id }) {
    commit("loading", true);
    popUpsApi.deactive(id).then(
      (response) => {
        dispatch("refreshPopUps", {
          restaurant_id: restaurant_id ? restaurant_id : null,
        });
        commit("notifications", { title: "popUps.DisablePopUpOK" });
        commit("loading", false);
        commit("showNotifications", true);
      },
      (error) => {
        commit("notifications", {
          title: "popUps.DisablePopUpKO",
          color: "danger",
        });
        commit("loading", false);
        commit("showNotifications", true);
      }
    );
  },

  editPopUp({ commit, dispatch }, { id, popUp, restaurant_id }) {
    commit("loading", true);
    popUpsApi.edit(id, popUp).then(
      () => {
        dispatch("refreshPopUps", {
          restaurant_id: restaurant_id ? restaurant_id : null,
        });
        commit("notifications", { title: "popUps.EditedPopUp" });
        commit("loading", false);
        commit("setpopupEditPopUp", false);
        commit("showNotifications", true);
      },
      () => {
        commit("notifications", {
          title: "popUps.EditedPopUpKO",
          color: "danger",
        });
        commit("loading", false);
        commit("showNotifications", true);
      }
    );
  },

  editPopUpChangeLanguage(
    { commit, dispatch },
    { id, dish, language, newLanguage }
  ) {
    commit("loading", true);
    popUpsApi.edit(id, dish, language).then(
      (response) => {
        commit("setpopupEditPopUp", false);
        commit("setItemPopUp", {});
        dispatch("getPopUp", { id, language: newLanguage });
        commit("setpopupEditPopUp", true);
      },
      // eslint-disable-next-line sonarjs/no-identical-functions
      (error) => {
        commit("notifications", {
          title: "product.NotProductoEditado",
          color: "danger",
        });
        commit("loading", false);
        commit("showNotifications", true);
      }
    );
  },
};

const getters = {
  getPopUp: (state) => state.item,
  getPopUps: (state) => state.items,
  getpopupNewPopUp: (state) => state.popupNewPopUp,
  getpopupEditPopUp: (state) => state.popupEditPopUp,
  getpopupSeePopUp: (state) => state.popupSeePopUp,
  getCreatedCorrectPopUp: (state) => state.createdCorrect,
};

export default {
  state: popUps,
  mutations,
  actions,
  getters,
};
